import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import Highcharts from 'highcharts';
import ReactHighcharts  from 'react-highcharts';
import { CircularProgress, Button, Modal } from "@material-ui/core";
import { number } from "../../../utils";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import { Close, DateRange } from "@material-ui/icons";

import diagnosticIcon from "../../../assets/Icons/diagnostic_rule-01.png";
import learnedIcon from "../../../assets/Icons/learned_rule-01.png";
import verificationIcon from "../../../assets/Icons/verification_rule-01.png";
import failedIcon from "../../../assets/Icons/failed-01.png";

import ec_line from "../../../assets/Svgs/ec-line.svg";
import at_line from "../../../assets/Svgs/at-line.svg";
import aa_shape from "../../../assets/Svgs/aa-shape.svg";
import dr_shape from "../../../assets/Svgs/dr-shape.svg";
import ic_shape from "../../../assets/Svgs/ic-shape.svg";
import pst_square from "../../../assets/Svgs/pst-square.svg";
import lrc_line from "../../../assets/Svgs/lrc-line.svg";
import vrf_line from "../../../assets/Svgs/vrf-line.svg";
import co_shape from "../../../assets/Svgs/co-shape.svg";

import styles from "./styles.scss";

const topConfig = {
    chart:{
        animation: false,
        zoomType: "x",
        turboThreshold: 0,
        panning: true,
        panKey: 'shift',
        style: {
            fontFamily: "Helvetica",
        }
    },
    credits: {
        enabled: false,
    },
    plotOptions: {
        column: {
            pointPadding: 0.05,
            groupPadding: 0,
            borderWidth: 0,
            pointWidth: 5,
        },
        line: {
            dataGrouping: {
                enabled: false,
                groupAll: true,
            },
            turboThreshold: 0,
        },
    },
    title: {
      text: "",
      align: "left",
      margin: 60,
      style: {
          "color": "#4D4D4D",
          "font-size": "20px",
          "font-weight": "600"
      },
    },
    legend: {
        enabled: false,
    },
    tooltip: {
        enabled: false,
    },
    xAxis: {
        type: 'datetime',
		tickWidth: 0,
        dateTimeLabelFormats: {
            month: '%e %b',
            year: '%b'
        },
        title: {
            text: ''
        },
        lineColor: '#e6e6e6',
        showEmpty: true,
        labels: {
            y: 30,
            style: {
                fontSize: "14px",
                color: '#999',
            }
        }
    },
    yAxis:[
        {
            visible: false,
            title: {
                text: "energyCostsDollars",
                units: "$",
            },
        },
        {
            visible: false,
            title: {
                text: "energyCostsKwh",
                units: "kWh",
            },
        },
        {
            visible: false,
            title: {
                text: "ambientTemperature",
                units: "&deg;C",
            },
        },
        {
            visible: false,
            title: {
                text: "automatedActions"
            },
            min: 0,
            max: 1, 
        },
        {
            visible: false,
            title: {
                text: "diagnosticRules"
            },
            min: 0,
            max: 1, 
        },
        {
            visible: false,
            title: {
                text: "implementedChanges"
            },
            min: 0,
            max: 1, 
        },
        {
            visible: false,
            title: {
                text: "preSetTests"
            },
        },
        {
            visible: false,
            title: {
                text: "verificationRuleFailures",
                units: "",
            },
        },
        {
            visible: false,
            title: {
                text: "comments"
            },
            min: 0,
            max: 1, 
        },
        {
            visible: false,
            title: {
                text: "learnedRuleChanges"
            },
        },
    ],
    series: [],
};

@CSSModules(styles, { allowMultiple: true })
class EvidenceChart extends Component {
    constructor(props){
        super(props);
        this.topChart = React.createRef();
        this.bottomChart = React.createRef();

        if(this.props.ruleInstanceId) {
            this.props.setRuleInstanceId(this.props.ruleInstanceId);
        }

        this.state = {
            hasAddedMouseMove: false,
        };

        this.setup = this.setup.bind(this);
        this.onChartMouseMove = this.onChartMouseMove.bind(this);
        this.openImplementedChangeListModal = this.openImplementedChangeListModal.bind(this);
    }
    
	render() {
		return (
            <div>
                <div styleName="chartcontentwrap sectiontitle">Timeline</div>
                <div styleName="chartcontentwrap chartbuttonwrap">
                    {
                        this.props.showEnergyCostsDollars === true && <div styleName="chartbutton color-ec" onClick={() => {this.props.toggleEnergyCostsDollars(this.topChart.current.chart, false);}}>{this.props.isBusyECD && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyECD && <img src={ec_line} alt="" styleName="linewrap twentyfive" />}Energy Costs</div>
                    }
                    {
                        this.props.showEnergyCostsDollars !== true && <div styleName="chartbutton color-none" onClick={() => {this.props.toggleEnergyCostsDollars(this.topChart.current.chart, true); this.props.toggleEnergyCostsKwh(this.topChart.current.chart, false)}}>{this.props.isBusyECD && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyECD && <img src={ec_line} alt="" styleName="linewrap disabled twentyfive" />}Energy Costs</div>
                    }
                    {
                        this.props.showEnergyCostsKwh !== true && <div styleName="chartbutton color-none" onClick={() => {this.props.toggleEnergyCostsDollars(this.topChart.current.chart, false); this.props.toggleEnergyCostsKwh(this.topChart.current.chart, true)}}>{this.props.isBusyECK && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyECK && <img src={ec_line} alt="" styleName="linewrap disabled twentyfive" />}kWh</div>
                    }
                    {
                        this.props.showEnergyCostsKwh === true && <div styleName="chartbutton color-ec" onClick={() => {this.props.toggleEnergyCostsKwh(this.topChart.current.chart, false);}}>{this.props.isBusyECK && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyECK && <img src={ec_line} alt="" styleName="linewrap twentyfive" />}kWh</div>
                    }
                </div>
                <div styleName="chartcontentwrap">
                    <div
                    id="topChartHighCharts">
                        <ReactHighcharts
                        id="topChart"
                        config={topConfig}
                        ref={this.topChart}
                        isPureConfig={true}
                        />
                    </div>
                </div>
                <div styleName="chartcontentwrap sectiontitle">View</div>
                <div styleName="chartcontentwrap chartbuttonwrap">
                    {
                        this.props.showAmbientTemperature &&
                        <div styleName="chartbutton color-at" onClick={() => this.props.toggleAmbientTemperature(this.topChart.current.chart, false)}>{this.props.isBusyAT && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyAT && <img src={at_line} alt="" styleName="linewrap twentyfive" />}Ambient Temperature</div>
                    }
                    {
                        !this.props.showAmbientTemperature &&
                        <div styleName="chartbutton color-none" onClick={() => this.props.toggleAmbientTemperature(this.topChart.current.chart, true)}>{this.props.isBusyAT && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyAT && <img src={at_line} alt="" styleName="linewrap disabled twentyfive" />}Ambient Temperature</div>
                    }

                    {/*
                        this.props.showAutomatedActions &&
                        <div styleName="chartbutton color-aa" onClick={() => this.props.toggleAutomatedActions(this.topChart.current.chart, false)}>{this.props.isBusyAA && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyAA && <img src={aa_shape} alt="" styleName="linewrap twentyfive" />}Automated Actions</div>
                    }
                    {
                        !this.props.showAutomatedActions &&
                        <div styleName="chartbutton color-none" onClick={() => this.props.toggleAutomatedActions(this.topChart.current.chart, true)}>{this.props.isBusyAA && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyAA && <img src={aa_shape} alt="" styleName="linewrap disabled twentyfive" />}Automated Actions</div>
                    */}

                    {
                        this.props.showDiagnosticRules &&
                        <div styleName="chartbutton color-dr" onClick={() => this.props.toggleDiagnosticRules(this.topChart.current.chart, false)}>{this.props.isBusyDR && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyDR && <img src={dr_shape} alt="" styleName="linewrap twentyfive" />}Diagnostic Rules</div>
                    }
                    {
                        !this.props.showDiagnosticRules &&
                        <div styleName="chartbutton color-none" onClick={() => this.props.toggleDiagnosticRules(this.topChart.current.chart, true)}>{this.props.isBusyDR && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyDR && <img src={dr_shape} alt="" styleName="linewrap disabled twentyfive" />}Diagnostic Rules</div>
                    }

                    {
                        this.props.showImplementedChanges &&
                        <div styleName="chartbutton color-ic" onClick={() => this.props.toggleImplementedChanges(this.topChart.current.chart, false)}>{this.props.isBusyIC && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyIC && <img src={ic_shape} alt="" styleName="linewrap twentyfive" />}Implemented Changes</div>
                    }
                    {
                        !this.props.showImplementedChanges &&
                        <div styleName="chartbutton color-none" onClick={() => this.props.toggleImplementedChanges(this.topChart.current.chart, true)}>{this.props.isBusyIC && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyIC && <img src={ic_shape} alt="" styleName="linewrap disabled twentyfive" />}Implemented Changes</div>
                    }

                    {
                        this.props.showPreSetTests &&
                        <div styleName="chartbutton color-pst" onClick={() => this.props.togglePreSetTests(this.topChart.current.chart, false, this.props.navigate)}>{this.props.isBusyPST && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyPST && <img src={pst_square} alt="" styleName="linewrap twentyfive" />}Pre-Set Tests</div>
                    }
                    {
                        !this.props.showPreSetTests &&
                        <div styleName="chartbutton color-none" onClick={() => this.props.togglePreSetTests(this.topChart.current.chart, true, this.props.navigate)}>{this.props.isBusyPST && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyPST && <img src={pst_square} alt="" styleName="linewrap disabled twentyfive" />}Pre-Set Tests</div>
                    }

                    {
                        this.props.showLearnedRuleChanges &&
                        <div styleName="chartbutton color-lrc" onClick={() => this.props.toggleLearnedRuleChanges(this.topChart.current.chart, false)}>{this.props.isBusyLRC && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyLRC && <img src={lrc_line} alt="" styleName="linewrap twentyfive" />}Learned Rule Changes</div>
                    }
                    {
                        !this.props.showLearnedRuleChanges &&
                        <div styleName="chartbutton color-none" onClick={() => this.props.toggleLearnedRuleChanges(this.topChart.current.chart, true)}>{this.props.isBusyLRC && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyLRC && <img src={lrc_line} alt="" styleName="linewrap disabled twentyfive" />}Learned Rule Changes</div>
                    }

                    {
                        this.props.showVerificationRuleFailures &&
                        <div styleName="chartbutton color-vrf" onClick={() => this.props.toggleVerificationRuleFailures(this.topChart.current.chart, false)}>{this.props.isBusyVRF && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyVRF && <img src={vrf_line} alt="" styleName="linewrap twentyfive" />}Verification Rule Failures</div>
                    }
                    {
                        !this.props.showVerificationRuleFailures &&
                        <div styleName="chartbutton color-none" onClick={() => this.props.toggleVerificationRuleFailures(this.topChart.current.chart, true)}>{this.props.isBusyVRF && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyVRF && <img src={vrf_line} alt="" styleName="linewrap disabled twentyfive" />}Verification Rule Failures</div>
                    }

                    {
                        this.props.showComments &&
                        <div styleName="chartbutton color-co" onClick={() => this.props.toggleComments(this.topChart.current.chart, false)}>{this.props.isBusyCO && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyVRF && <img src={co_shape} alt="" styleName="linewrap twentyfive" />}Comments</div>
                    }
                    {
                        !this.props.showComments &&
                        <div styleName="chartbutton color-none" onClick={() => this.props.toggleComments(this.topChart.current.chart, true)}>{this.props.isBusyCO && <CircularProgress size={25} styleName="linewrap" />}{!this.props.isBusyVRF && <img src={co_shape} alt="" styleName="linewrap disabled twentyfive" />}Comments</div>
                    }


                </div>
                {
                    this.props.isMouseIn &&
                    <div id="pst-tooltip" className="pst-tooltip" style={{visibility: "hidden", height: "0px"}}>
                        <div>
                            <div className="date-description">
                                {moment.utc(this.props.mouseX).format("dddd, MMM DD, hh:mm A")}
                            </div>
                            {
                                this.props.nearestECD &&
                                <div className="major-description description"><span className="color-ec">Energy Cost ($):</span> {number.parseNumber(this.props.nearestECD.y, 2)}</div>
                            }
                            {
                                this.props.nearestECK &&
                                <div className="major-description description"><span className="color-ec">Energy Cost (kWh):</span> {number.parseNumber(this.props.nearestECK.y, 0)}</div>
                            }
                            {
                                this.props.nearestAT &&
                                <div className="major-description description"><span className="color-at">Ambient Temperature (&deg;C):</span> {number.parseNumber(this.props.nearestAT.y, 1)}</div>
                            }
                            {
                                this.props.nearestLRC &&
                                <div className="major-description description"><span className="color-lrc">Learned Rule Change:</span> {this.props.nearestLRC.y}</div>
                            }
                            {
                                this.props.nearestVRF &&
                                <div className="major-description description"><span className="color-vrf">Verification Rule Failures:</span> {this.props.nearestVRF.y}</div>
                            }
                            {
                                /*
                                this.props.nearestAA &&
                                <div className="major-description description tooltip-top-gap">
                                    <span className="color-aa">Automated Action{this.props.nearestAA.data.length > 1 ? "s" : ""}:</span>
                                    <br />
                                    {
                                        this.props.nearestAA.data.map((d, index) => {
                                            return (<span>- {d.description}<br /></span>)
                                        })
                                    }
                                </div>
                                */
                            }
                            {
                                this.props.nearestDR &&
                                <div className="major-description description tooltip-top-gap">
                                    <span className="color-dr">Diagnostic Rule{this.props.nearestDR.data.length > 1 ? "s" : ""}:</span>
                                    <br />
                                    {
                                        this.props.nearestDR.data.map((d, index) => {
                                            return (<span>- {d.name}<br /></span>)
                                        })
                                    }
                                </div>
                            }
                            {
                                this.props.nearestIC &&
                                <div className="major-description description tooltip-top-gap">
                                    <span className="color-ic">Implemented Change{this.props.nearestIC.data.length > 1 ? "s" : ""}:</span>
                                    <br />
                                    {
                                        this.props.nearestIC.data.map((d, index) => {
                                            return (<span key={index}>- {d.description}<br /></span>)
                                        })
                                    }
                                </div>
                            }
                            {
                                this.props.nearestPST &&
                                <div className="major-description description tooltip-top-gap"><span className="color-pst">Pre-Set Test:</span><br />{this.props.nearestPST.description}</div>
                            }
                            {
                                this.props.nearestPST && this.props.nearestPST.preSetTestItems && this.props.nearestPST.preSetTestItems.length && this.props.nearestPSTI &&
                                this.props.nearestPST.preSetTestItems.map((psti, index) => {
                                    return (
                                        <div key={index} className="minor-description description"><div className={"pst-tooltip-number" + (psti.preSetTestItemId === this.props.nearestPSTI.preSetTestItemId ? " pst-tooltip-bold" : "")}>{(index + 1)}</div>{psti.description}</div>
                                    )
                                })
                            }
                            {
                                this.props.nearestCO &&
                                <div className="major-description description tooltip-top-gap">
                                    <span className="color-co">Comment{this.props.nearestCO.data.length > 1 ? "s" : ""}:</span>
                                    <br />
                                    {
                                        this.props.nearestCO.data.map((d, index) => {
                                            return (<span>- {d.description}<br /></span>)
                                        })
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
                {
                    this.props.isMouseIn &&
                    <div id="pst-bar" className="pst-bar" style={{visibility: "hidden", height: "0px"}}>
                    </div>
                }
                {this.getImplementedChangeListModal()}
                
            </div>
		);
    }

    openImplementedChangeListModal(data) {
        this.setState({implementedChangeListOpen: true, implementedChangeList: data});
    }

	getImplementedChangeListModal() {
		return (
			<Modal open={this.state.implementedChangeListOpen}
				styleName="chart-modal-container"
				onClose={() => {
					this.setState({ implementedChangeListOpen: false });
				}}>
				<div className="modal-wrap">
					<div style={{marginTop: -10, marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
						<div style={{flex: 1}} />
						<CloseIcon onClick={() => this.setState({ implementedChangeListOpen: false })}/>
					</div>
                    <div styleName="chart-modal-content" style={{display: "flex", flexDirection: "column"}}>
                        <div styleName="modal-title">Pick an Implemented Change</div>
                        <div style={{display: "flex", flexDirection: "column", flexWrap: "wrap", marginTop: 10}}>
                            {
                                (this.state.implementedChangeList !== undefined && this.state.implementedChangeList !== null &&
                                this.state.implementedChangeList.length > 0) &&
                                this.state.implementedChangeList.map((ic, index) => {
                                    return (
                                        <div styleName="ic-list-item" key={index} onClick={() => this.props.navigate("/Evidence/Report/" + ic.siteName + "/" + (ic.iEnergyViewId !== undefined && ic.iEnergyViewId !== null ? ic.iEnergyViewId : "null") + "/ImplementedChange/" + ic.implementedChangeId)}>
                                        <img src={ic_shape} styleName="linewrap twentyfive" alt="" />
                                        {ic.description}
                                        </div>
                                    )
                                })
                            }
                        </div>
					</div>
				</div>
			</Modal>
		);
	} 

    onChartMouseMove(e) {
        e = this.topChart.current.chart.pointer.normalize(e);

        let x = Math.floor(this.topChart.current.chart.xAxis[0].toValue(e.chartX));
        let isIn = this.topChart.current.chart.isInsidePlot(e.chartX - this.topChart.current.chart.plotLeft, e.chartY - this.topChart.current.chart.plotTop);
        
        this.props.mouseMovedInContainer(x, isIn, moment().valueOf());

        let pstTooltip = document.getElementById("pst-tooltip");
        let highchartDiv = document.getElementById("topChartHighCharts");
        let pstBar = document.getElementById("pst-bar");
        let sc = document.getElementById("content-scroll");
        let offsetHighchartsDiv = document.getElementById("topChartHighCharts").childNodes[0].childNodes[0].childNodes[0].childNodes;
        let actualOffset = null;
        for(var xx = 0; xx < offsetHighchartsDiv.length; xx++) {
            if(offsetHighchartsDiv[xx].className.animVal === "highcharts-plot-border") {
                actualOffset = offsetHighchartsDiv[xx];
                break;
            }
        }
        if(!pstTooltip || !highchartDiv) {return;}

        let left = 0;
        let barLeft = highchartDiv.offsetLeft + e.offsetX - 1;
        if(highchartDiv.offsetWidth - 350 < highchartDiv.offsetLeft + e.offsetX) {
            left = highchartDiv.offsetLeft + e.offsetX - 350;
        } else {
            left = highchartDiv.offsetLeft + 18 + e.offsetX;
        }


        if(this.props.isMenuOpen) {
            left += 200;
            barLeft += 200;
        }

        pstTooltip.setAttribute("style", "top: " + (e.pageY) + "px; left: " + left + "px;");
        pstTooltip.setAttribute("class", "pst-tooltip");

        pstBar.setAttribute("style", "top: " + ((highchartDiv.offsetTop) + 50 - sc.scrollTop + (Number(actualOffset.getAttribute("y")))) + "px; left: " + barLeft + "px; height: " + Number(actualOffset.getAttribute("height")) + "px;");
        pstBar.setAttribute("class", "pst-bar");
    }

    setup(){
        if(!this.props.isBusy) {
            this.props.loadData(this.topChart.current.chart, this.props.time, this.props.navigate, this.openImplementedChangeListModal);
            this.topChart.current.getChart().reflow();
            
            if(!this.state.hasAddedMouseMove) {
                this.setState({hasAddedMouseMove: true});
                let x = document.getElementById("topChartHighCharts").childNodes[0].childNodes[0];
                x.addEventListener("mousemove", this.onChartMouseMove);
            }
        }
    }

    teardown(){
    }

    componentDidMount(){
        this.setup();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        this.setup();
    }

    componentWillUnmount() {
        this.props.resetCurrentLoaded();
        this.props.resetToggled();
    }

}

const bindAction = dispatch => {
    return {
        loadData: (topChart, time, navigateFunc, openImplementedChangeListModalFunc) => dispatch(actions.loadData(topChart, time, navigateFunc, openImplementedChangeListModalFunc)),

        toggleEnergyCostsDollars: (chart, val) => dispatch(actions.toggleEnergyCostsDollars(chart, val)),
        toggleEnergyCostsKwh: (chart, val) => dispatch(actions.toggleEnergyCostsKwh(chart, val)),
        toggleAmbientTemperature: (chart, val) => dispatch(actions.toggleAmbientTemperature(chart, val)),
        toggleAutomatedActions: (chart, val) => dispatch(actions.toggleAutomatedActions(chart, val)),
        toggleDiagnosticRules: (chart, val) => dispatch(actions.toggleDiagnosticRules(chart, val)),
        toggleImplementedChanges: (chart, val) => dispatch(actions.toggleImplementedChanges(chart, val)),
        togglePreSetTests: (chart, val, navigateFunc) => dispatch(actions.togglePreSetTests(chart, val, navigateFunc)),
        toggleLearnedRuleChanges: (chart, val) => dispatch(actions.toggleLearnedRuleChanges(chart, val)),
        toggleVerificationRuleFailures: (chart, val) => dispatch(actions.toggleVerificationRuleFailures(chart, val)),
        toggleComments: (chart, val) => dispatch(actions.toggleComments(chart, val)),
        mouseMovedInContainer: (x, isIn, now) => dispatch(actions.mouseMovedInContainer(x, isIn, now)),
        resetToggled: () => dispatch(actions.resetToggled()),

        setRuleInstanceId: () => dispatch(actions.setRuleInstanceId()),
        resetCurrentLoaded: () => dispatch(actions.resetCurrentLoaded()),

        navigate: (uri, data) => dispatch(router.push(uri, data)),
    };
};

const mapStateToProps = (state, ownProps) => ({
    evidenceTime: state.evidenceService.time,

    isBusy: state.evidenceComponentChart.isBusy,
    isBusyECD: state.evidenceComponentChart.isBusyECD,
    isBusyECK: state.evidenceComponentChart.isBusyECK,
    isBusyAT: state.evidenceComponentChart.isBusyAT,
    isBusyAA: state.evidenceComponentChart.isBusyAA,
    isBusyDR: state.evidenceComponentChart.isBusyDR,
    isBusyIC: state.evidenceComponentChart.isBusyIC,
    isBusyPST: state.evidenceComponentChart.isBusyPST,
    isBusyLRC: state.evidenceComponentChart.isBusyLRC,
    isBusyVRF: state.evidenceComponentChart.isBusyVRF,
    isBusyCO: state.evidenceComponentChart.isBusyCO,

	showEnergyCostsDollars: state.evidenceComponentChart.showEnergyCostsDollars,
	showEnergyCostsKwh: state.evidenceComponentChart.showEnergyCostsKwh,
	showAmbientTemperature: state.evidenceComponentChart.showAmbientTemperature,
	showAutomatedActions: state.evidenceComponentChart.showAutomatedActions,
	showDiagnosticRules: state.evidenceComponentChart.showDiagnosticRules,
	showImplementedChanges: state.evidenceComponentChart.showImplementedChanges,
	showPreSetTests: state.evidenceComponentChart.showPreSetTests,
	showLearnedRuleChanges: state.evidenceComponentChart.showLearnedRuleChanges,
    showVerificationRuleFailures: state.evidenceComponentChart.showVerificationRuleFailures,
    showComments: state.evidenceComponentChart.showComments,
    currentTariff: state.tariffs.currentTariff,

    isMouseIn: state.evidenceComponentChart.isMouseIn,
    mouseX: state.evidenceComponentChart.mouseX,
    nearestECD: state.evidenceComponentChart.nearestECD,
    nearestECK: state.evidenceComponentChart.nearestECK,
    nearestAT: state.evidenceComponentChart.nearestAT,
    nearestAA: state.evidenceComponentChart.nearestAA,
    nearestDR: state.evidenceComponentChart.nearestDR,
    nearestIC: state.evidenceComponentChart.nearestIC,
    nearestPST: state.evidenceComponentChart.nearestPST,
    nearestPSTI: state.evidenceComponentChart.nearestPSTI,
    nearestLRC: state.evidenceComponentChart.nearestLRC,
    nearestVRF: state.evidenceComponentChart.nearestVRF,
    nearestCO: state.evidenceComponentChart.nearestCO,

	isMenuOpen: state.menu.isOpen
});

export default connect(mapStateToProps, bindAction)(EvidenceChart);



// WEBPACK FOOTER //
// ./src/components/EvidenceComponents/Chart/EvidenceChart.js